import * as React from 'react'

import { getLoginUrl, getWhitelabelBranding } from 'main/components/common/AuthModal/ssoNavigation'
import Loader from 'main/components/common/Loader'
import { useWhitelabel } from 'main/framework'
import useSSOContext from 'main/hooks/useSSOContext'

import { AssetName } from 'main/util/asset'
import { ISSOTrackingProps } from '../types'
import { Container } from './LoginForm.styles'

export default function LoginFormSSO(props: ISSOTrackingProps) {
  const { navContext } = useSSOContext() // this page doesn't set its own nav context but might pass along some
  const whitelabel = useWhitelabel()

  const extraContext = {
    networkId: props?.extraData?.networkId || whitelabel?.networkId,
    ...getWhitelabelBranding(whitelabel),
  }

  const canSignUp = whitelabel.evaluateToTrueExceptIfFalse(AssetName.SIGN_UP__SSOLOGIN)
  const noSignupMode = !canSignUp

  const joinUrl = getLoginUrl(props, navContext, extraContext, undefined, noSignupMode)

  React.useEffect(() => {
    window.location.replace(joinUrl)
  })

  return (
    <Container>
      <Loader />
    </Container>
  )
}
